module.exports = __webpack_public_path__ + "img/ic-chevron-right.7688b829.svg";